import { BalaklavaIcon } from '@vlabs/icons';
import { calculateProbabilityPercent } from '@vlabs/monokit/shared/lib/utils';
import { Tag } from '@vlabs/uikit';

const buildFacecoverConfigV1 = (event) => {
  const scoreRaw = event?.event?.facecover_score;
  const scorePercent = typeof scoreRaw === 'number'
    ? `${calculateProbabilityPercent(scoreRaw)}%`
    : null;

  return {
    score: { value: scorePercent },
    frame: {
      detections: event.event?.overview?.detection ? [event.event?.overview?.detection] : [],
      type: 'bbox',
    },
  };
};

const buildFacecoverConfigV2 = (event, t, width) => {
  const subtype = event?.event_type;
  const scoreRaw = event?.event?.best_detection?.[`${subtype}_score`];
  const scorePercent = typeof scoreRaw === 'number'
    ? `${calculateProbabilityPercent(scoreRaw)}%`
    : null;

  const bbox = event?.event?.overview?.detection
    ?? event?.event?.best_detection?.detection
    ?? null;

  return {
    score: {
      value: scorePercent,
    },
    info: {
      extraTags: <Tag
        // className={st.FireTag}
        icon={<BalaklavaIcon />}
        size={width < 1920 ? 'medium' : 'large'}
        value={t(`videoAnalytics:facecoverAnalyticDetailsV2.subtypes.${subtype}`)}
      />,
    },
    frame: {
      detections: bbox ? [bbox] : [],
      type: 'bbox',
    },
  };
};

export const FACE_COVER_DISPLAY_BUILDERS = {
  v1: buildFacecoverConfigV1,
  v2: buildFacecoverConfigV2,
};
